/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import MockAdapter from 'axios-mock-adapter';
import { BaseFeatureMock } from '../mockServer/featureMock';
import { OperatorDetailsDto, OperatorsListDto, OperatorsListRequestParams } from './operatorsClient.typings';
import { operatorCashBoxesStatsFactory, operatorDetailsFactory, operatorDtoFactory } from './operatorsFactories';
import { CashBoxesStats } from '../cashBoxes/cashBoxesClient.typings';

const OPERATORS_LIST_URL = /\/operators$/;
const OPERATOR_DETAILS_URL = /\/operators\/\d+/;
const OPERATOR_CASHBOXES_STATS = /\/operators\/(\d+)\/cashboxes\/stats/;
const OPERATORS_HOME_URL = /\/operators\/home/;

class OperatorsFeatureMock extends BaseFeatureMock {
    public readonly listOperators = this.route<OperatorsListDto, OperatorsListRequestParams>({
        method: 'post',
        url: OPERATORS_LIST_URL,
        defaultResponse: (config) => {
            const body = JSON.parse(config.data);
            const data: OperatorsListDto = {
                afterKey: '2638000008',
                operators: operatorDtoFactory.list({ count: body.limit }),
            };

            return [200, data];
        },
        delayMs: () => Math.random() * 100,
    });

    // OPERATOR_DETAILS_URL is unanchored (`/\/operators\/\d+/`) and would also match
    // `/operators/123/cashboxes/stats` or `/operators/home` - these more specific routes
    // must stay registered (declared) before it, since axios-mock-adapter matches in
    // first-registered-first-matched order.
    public readonly operatorCashboxesStats = this.route<CashBoxesStats>({
        method: 'get',
        url: OPERATOR_CASHBOXES_STATS,
        defaultResponse: () => {
            const data: CashBoxesStats = operatorCashBoxesStatsFactory.item();

            return [200, data];
        },
        delayMs: () => Math.random() * 100,
    });

    public readonly operatorAccHomeDetails = this.route<OperatorDetailsDto>({
        method: 'get',
        url: OPERATORS_HOME_URL,
        defaultResponse: () => {
            const data: OperatorDetailsDto = operatorDetailsFactory.item();

            return [200, data];
        },
        delayMs: () => Math.random() * 100,
    });

    public readonly operatorDetails = this.route<OperatorDetailsDto>({
        method: 'get',
        url: OPERATOR_DETAILS_URL,
        defaultResponse: () => {
            const data: OperatorDetailsDto = operatorDetailsFactory.item();

            return [200, data];
        },
        delayMs: () => Math.random() * 100,
    });

    protected onReset(): void {
        operatorDtoFactory.resetCount();
        operatorDetailsFactory.resetCount();
        operatorCashBoxesStatsFactory.resetCount();
    }
}

export const operatorsMock = new OperatorsFeatureMock();

/** Backward-compat shim - dev mock mode (mockAdapter.ts) keeps calling this untouched. */
export function addOperatorsMockApi(mockAdapter: MockAdapter): void {
    operatorsMock.register(mockAdapter, { delay: true });
}
